import React, { useContext, useEffect, useState, useRef } from "react";
import { Link, Routes, useParams, useNavigate } from "react-router-dom";
import ImageWithBasePath from "../core/common/imageWithBasePath";
import { all_routes } from "./router/all_routes";
import Header from "./Header";
import axios from "axios";
import { ProductContext } from "../context/AppContext";

const DocumentDownload = () => {
  const params = useParams();
  const [state, setState] = useState(null);
  const navigate = useNavigate();
  const { Dashboarddata } = useContext(ProductContext);
  const authtoken = localStorage.getItem("token");

  console.log(Dashboarddata, "Dashboarddata 1500 25600");

  const [Automationdata, setAutomationdata] = useState(null);

  useEffect(() => {
    const fetchSchoolAutomation = async () => {
      try {
        const response = await axios.get(
          "https://api.mirai.healthcare/api/head/school-rule/school-automation",
          {
            headers: {
              Accept: "application/json",
              "Accept-Language": "en-US,en;q=0.9",
              "If-None-Match": 'W/"1232-eA/5v59SADPlwXd2obsRqmE3IKY"',
              Origin: "http://localhost:3000",
              Referer: "http://localhost:3000/",
            },
          }
        );
        setAutomationdata(response);
      } catch (error) {
        console.error("Error fetching school automation data:", error);
      }
    };

    fetchSchoolAutomation();
  }, []);

  const handleDownload = (fileUrl, fileName) => {
    try {
      // Create an invisible link
      const link = document.createElement("a");
      link.href = fileUrl;
      link.setAttribute("download", fileName || "document"); // default file name
      link.setAttribute("target", "_blank"); // open in new tab if browser blocks download
      document.body.appendChild(link);
      link.click();
      link.remove();
    } catch (error) {
      console.error("Error downloading file:", error);
    }
  };

  const [downloadingIndex, setDownloadingIndex] = useState(null);

  const downloadFile = async (fileUrl, fileType = "application/pdf", index) => {
    try {
      setDownloadingIndex(index);

      const response = await fetch(fileUrl);
      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);
      const a = document.createElement("a");
      a.href = url;
      const extension = fileType.includes("/") ? fileType.split("/")[1] : "pdf";
      a.download = `notice_${Date.now()}.${extension}`;
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      window.alert("Error downloading file");
    } finally {
      setDownloadingIndex(null);
    }
  };

  const classIdNew = localStorage.getItem("ClassId");
  console.log(classIdNew, "classIdNew 1500");
  const [getExamData, setGetExamData] = useState(null);
  useEffect(() => {
    const fetchUserClassData = () => {
      fetch(`https://api.mirai.healthcare/api/exam?class_id=${classIdNew}`, {
        method: "GET",
        headers: {
          Accept: "application/json, text/plain",
          "Content-Type": "application/json;charset=UTF-8",
          "x-auth": `${authtoken}`,
        },
      })
        .then((response) => {
          if (!response.ok) {
            throw new Error(`HTTP error! status: ${response.status}`);
          }
          return response.json();
        })
        .then((response) => {
          setGetExamData(response);
        })
        .catch((error) => {
          console.error("Fetch error:", error);
        });
    };
    fetchUserClassData();
  }, []);

  const fetchExamDownloadData = async (examId) => {
    try {
      const response = await fetch(
        `https://api.mirai.healthcare/api/exam/syllabus?exam_id=${examId}`,
        {
          method: "GET",
          headers: {
            "x-auth": `${authtoken}`,
          },
        }
      );

      if (!response.ok) {
        throw new Error("Network response was not ok");
      }

      const data = await response.json();
      console.log("Exam Syllabus Data:", data);

      // ✅ Check if exam file exists
      const examFile = data?.message?.exams?.[0]?.file_url?.link;

      // if (examFile) {
      //   // ✅ If file found, trigger download
      //   const fileName = examFile.split("/").pop();
      //   const link = document.createElement("a");
      //   link.href = examFile;
      //   link.download = fileName || "exam-file";
      //   document.body.appendChild(link);
      //   link.click();
      //   document.body.removeChild(link);
      // } else {
      //   // ✅ If no file found, print message
      //   console.log("No file found for this exam.");
      //   alert("No file found for this exam.");
      // }
      if (examFile) {
        // ✅ Open in new tab instead of downloading
        window.open(examFile, "_blank", "noopener,noreferrer");
      } else {
        console.log("No file found for this exam.");
        alert("No file found for this exam.");
      }
    } catch (error) {
      console.error("Error fetching exam data:", error);
    }
  };

  return (
    <>
      <div className="page-wrapper">
        <div className="content">
          <Header />
          <div className="row">
            <div className="col-md-12">
              <div className="d-md-flex d-block align-items-center justify-content-between mb-3">
                <div className="my-auto mb-1 mt-3">
                  <h3 className="page-title mb-1">Document Details</h3>
                </div>
              </div>
            </div>

            <div className="col-xxl-12 col-xl-12">
              <div className="row">
                {/* Documents */}
                <div className="col-xxl-12">
                  <div className="card">
                    <div className="card-header">
                      <h5>Documents</h5>
                    </div>

                    <div className="">
                      <div className="row mt-2">
                        {Automationdata?.data?.[0]?.feeStructure &&
                        Automationdata?.data?.[0]?.feeStructure.length > 0 ? (
                          <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>Fee Structure</h5>
                              </div>
                              <div className="card-body text-center">
                                {Automationdata?.data?.[0]?.feeStructure ? (
                                  <img
                                    src={
                                      Automationdata?.data?.[0]?.feeStructure
                                    }
                                    className="img-fluid rounded Parent_image"
                                    alt="Birth Certificate"
                                  />
                                ) : (
                                  <ImageWithBasePath
                                    src="assets/img/students/student-01.jpg"
                                    className="img-fluid Parent_image"
                                    alt="img"
                                  />
                                )}
                                <button
                                  className="btn btn-primary align-center"
                                  style={{ width: "100%", marginTop: 10 }}
                                  onClick={() =>
                                    handleDownload(
                                      Automationdata?.data?.[0]?.feeStructure,
                                      "feeStructure.jpg"
                                    )
                                  }
                                >
                                  Download
                                </button>
                              </div>
                            </div>
                          </div>
                        ) : null}
                        {/* {Dashboarddata?.data?.isAdmission === false && (
                        <>
{getExamData?.message?.exam?.map((examdata, index) => {
                        return (
                        <div className="col-md-4">
                            <div className="card flex-fill">
                              <div className="card-header">
                                <h5>{examdata?.name}</h5>
                              </div>
                              <div className="card-body text-center">
                                
                                <button
                                  className="btn btn-primary align-center"
                                  style={{ width: "100%", marginTop: 10 }}
                                  onClick={() => fetchExamDownloadData(examdata?.id)}
                                >
                                  Download Syllabus
                                </button>
                              </div>
                            </div>
                          </div>
                        )})}
                        </>
                        )} */}

                        {!Dashboarddata?.data?.isAdmission && (
                          <>
                            {getExamData?.message?.exam?.map(
                              (examdata, index) => (
                                <div className="col-md-4" key={index}>
                                  <div className="card flex-fill">
                                    <div className="card-header">
                                      <h5>{examdata?.name}</h5>
                                    </div>
                                    <div className="card-body text-center">
                                      <button
                                        className="btn btn-primary align-center"
                                        style={{ width: "100%", marginTop: 10 }}
                                        onClick={() =>
                                          fetchExamDownloadData(examdata?.id)
                                        }
                                      >
                                        Download Syllabus
                                      </button>
                                    </div>
                                  </div>
                                </div>
                              )
                            )}
                          </>
                        )}
                      </div>
                    </div>
                  </div>
                </div>
                {/* /Documents */}
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default DocumentDownload;
